module.exports = __webpack_public_path__ + "static/img/kwh_top_edit_img.9015dea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productConter/kwh_top_edit_img.png
// module id = VYPw
// module chunks = 1